// extracted by mini-css-extract-plugin
export var date = "careers-post-module--date--d1dcb";
export var linkWrapper = "careers-post-module--linkWrapper--f9372";
export var root = "careers-post-module--root--0ba27";